import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import { TrashcanIcon } from "../icons/reader/TrashcanIcon";
import { EditIcon } from "../icons/EditIcon";
import { MoreIcon } from "../icons/MoreIcon";
import { t } from "i18next";

export function CommentPopoverMenu({
  onEdit,
  onDelete,
}: {
  onEdit?: () => void;
  onDelete?: () => void;
}) {
  return (
    <Popover variant="contextualMenu" placement="bottom-end">
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <Button
              variant="iconOnly"
              minWidth="none"
              padding="4px"
              px="6px"
              borderRadius="14px"
              background={isOpen ? "transparent.white.10" : "transparent"}
            >
              <MoreIcon boxSize="20px" color="dune.dune" />
            </Button>
          </PopoverTrigger>
          <PopoverContent>
            {onEdit && (
              <Button variant="contextMenuButton" onClick={onEdit}>
                {t("components.comments.edit")}
                <EditIcon boxSize="20px" />
              </Button>
            )}
            {onDelete && (
              <Button variant="contextMenuButton" onClick={onDelete}>
                {t("components.comments.delete")}
                <TrashcanIcon boxSize="20px" />
              </Button>
            )}
          </PopoverContent>
        </>
      )}
    </Popover>
  );
}
